export const gettersTypes = {};

const getters = {};

export default getters;
